<div>
  @if (errorMessage()) {
    <div class="errorMessage">
      {{ errorMessage() }}
    </div>
  }
  <div class="results">
    <app-documentation-tree [nodes]="documentationNodes()" [expanded]="openDocumentation()"
      [selectedCategory]="selectedCategory()" (downloadRequested)="download($event)">
    </app-documentation-tree>
    <!-- <app-documentation-tree [nodes]="softwareNodes()" [sharingAllowed]="true" [expanded]="openSoftware()"
    (shareRequested)="shareSoftware($event.name)"
  (downloadRequested)="downloadSoftware($event)"></app-documentation-tree>
  <app-documentation-tree [nodes]="revitFileNodes()" [sharingAllowed]="true" [expanded]="openRevit()"
    (shareRequested)="shareRevit($event.name)"
  (downloadRequested)="downloadRevit($event)"></app-documentation-tree>
  <app-documentation-tree [nodes]="presentationFileNodes()" [expanded]="openPresentations()"
  (downloadRequested)="downloadPresentation($event)"></app-documentation-tree> -->
</div>
</div>
@if (isBusy()) {
  <div class="busyIndicator">
    <div class="busyContents">
      <mat-progress-spinner diameter="48" mode="indeterminate"></mat-progress-spinner>
      <label class="busyLabel">Please Wait...</label>
    </div>
  </div>
}
